// // pages/logs/pages/FraudManagement/CreateFraudRule.jsx

// import React, { useState } from "react";
// import {
//   Box,
//   TextField,
//   Button,
//   MenuItem,
//   Typography,
//   Stack,
//   Card,
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import { createFraudRule } from "services/https/fraudManagementService";

// const initialState = {
//   ruleName: "",
//   ruleType: "",
//   riskLevel: "",
//   condition: "",
//   threshold: "",
//   status: "ACTIVE",
// };

// const CreateFraudRule = ({ openDialog, setOpenDialog }) => {
//   const [form, setForm] = useState(initialState);
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);


//   const handleChange = (key, value) => {
//     setForm((prev) => ({ ...prev, [key]: value }));
//   };

//   // ✅ Validation
//   const validate = () => {
//     let temp = {};

//     if (!form.ruleName) temp.ruleName = "Rule name is required";
//     if (!form.ruleType) temp.ruleType = "Rule type is required";
//     if (!form.riskLevel) temp.riskLevel = "Risk level is required";
//     if (!form.condition) temp.condition = "Condition is required";
//     if (!form.threshold) temp.threshold = "Threshold is required";

//     setErrors(temp);
//     return Object.keys(temp).length === 0;
//   };

//   // ✅ Submit
//   const handleSubmit = async () => {
//     if (!validate()) return;

//     try {
//       setLoading(true);

//       await createFraudRule({
//         ...form,
//         threshold: Number(form.threshold),
//       });

//       setOpenDialog(false);
//     } catch (err) {
//       console.error(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box p={3}>
//       <Card sx={{ p: 3, maxWidth: 600 }}>
//         <Typography variant="h6" mb={2}>
//           Create Fraud Rule
//         </Typography>

//         <Stack spacing={2}>
//           <TextField
//             label="Rule Name"
//             value={form.ruleName}
//             onChange={(e) => handleChange("ruleName", e.target.value)}
//             error={!!errors.ruleName}
//             helperText={errors.ruleName}
//             fullWidth
//           />

//           <TextField
//             select
//             label="Rule Type"
//             value={form.ruleType}
//             onChange={(e) => handleChange("ruleType", e.target.value)}
//             error={!!errors.ruleType}
//             helperText={errors.ruleType}
//           >
//             <MenuItem value="TRANSACTION">Transaction</MenuItem>
//             <MenuItem value="VELOCITY">Velocity</MenuItem>
//             <MenuItem value="GEO">Geo-location</MenuItem>
//           </TextField>

//           <TextField
//             select
//             label="Risk Level"
//             value={form.riskLevel}
//             onChange={(e) => handleChange("riskLevel", e.target.value)}
//             error={!!errors.riskLevel}
//             helperText={errors.riskLevel}
//           >
//             <MenuItem value="LOW">Low</MenuItem>
//             <MenuItem value="MEDIUM">Medium</MenuItem>
//             <MenuItem value="HIGH">High</MenuItem>
//           </TextField>

//           <TextField
//             label="Condition (e.g amount > 500000)"
//             value={form.condition}
//             onChange={(e) => handleChange("condition", e.target.value)}
//             error={!!errors.condition}
//             helperText={errors.condition}
//             fullWidth
//           />

//           <TextField
//             label="Threshold"
//             type="number"
//             value={form.threshold}
//             onChange={(e) => handleChange("threshold", e.target.value)}
//             error={!!errors.threshold}
//             helperText={errors.threshold}
//           />

//           <TextField
//             select
//             label="Status"
//             value={form.status}
//             onChange={(e) => handleChange("status", e.target.value)}
//           >
//             <MenuItem value="ACTIVE">Active</MenuItem>
//             <MenuItem value="INACTIVE">Inactive</MenuItem>
//           </TextField>

//           <Button
//             variant="contained"
//             onClick={handleSubmit}
//             disabled={loading}
//           >
//             {loading ? "Creating..." : "Create Rule"}
//           </Button>
//         </Stack>
//       </Card>
//     </Box>
//   );
// };

// export default CreateFraudRule;


import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  Stack,
} from "@mui/material";
import { useState } from "react";
import { createFraudRule } from "services/https/fraudManagementService";

const CreateFraudRule = ({ openDialog, setOpenDialog }) => {
  const [form, setForm] = useState({
    ruleName: "",
    ruleType: "",
    riskLevel: "",
    condition: "",
    threshold: "",
    status: "ACTIVE",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const validate = () => {
    let temp = {};

    if (!form.ruleName) temp.ruleName = "Required";
    if (!form.ruleType) temp.ruleType = "Required";
    if (!form.riskLevel) temp.riskLevel = "Required";
    if (!form.condition) temp.condition = "Required";
    if (!form.threshold) temp.threshold = "Required";

    setErrors(temp);
    return Object.keys(temp).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    try {
      setLoading(true);

      await createFraudRule({
        ...form,
        threshold: Number(form.threshold),
      });

      setOpenDialog(false); // ✅ close modal
    } catch (err) {
      console.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth maxWidth="sm">
      <DialogTitle>Create Fraud Rule</DialogTitle>

      <DialogContent>
        <Stack spacing={2} mt={1}>
          <TextField
            label="Rule Name"
            value={form.ruleName}
            onChange={(e) => handleChange("ruleName", e.target.value)}
            error={!!errors.ruleName}
            helperText={errors.ruleName}
            fullWidth
          />

          <TextField
            select
            label="Rule Type"
            value={form.ruleType}
            onChange={(e) => handleChange("ruleType", e.target.value)}
            error={!!errors.ruleType}
            helperText={errors.ruleType}
          >
            <MenuItem value="TRANSACTION">Transaction</MenuItem>
            <MenuItem value="VELOCITY">Velocity</MenuItem>
            <MenuItem value="GEO">Geo</MenuItem>
          </TextField>

          <TextField
            select
            label="Risk Level"
            value={form.riskLevel}
            onChange={(e) => handleChange("riskLevel", e.target.value)}
            error={!!errors.riskLevel}
            helperText={errors.riskLevel}
          >
            <MenuItem value="LOW">Low</MenuItem>
            <MenuItem value="MEDIUM">Medium</MenuItem>
            <MenuItem value="HIGH">High</MenuItem>
          </TextField>

          <TextField
            label="Condition"
            value={form.condition}
            onChange={(e) => handleChange("condition", e.target.value)}
            error={!!errors.condition}
            helperText={errors.condition}
          />

          <TextField
            label="Threshold"
            type="number"
            value={form.threshold}
            onChange={(e) => handleChange("threshold", e.target.value)}
            error={!!errors.threshold}
            helperText={errors.threshold}
          />
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={loading}>
          {loading ? "Creating..." : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateFraudRule;